module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showHeader) ? _c('div', {
    staticClass: "rel header_box"
  }, [_c('x-header', {
    style: ({
      background: _vm.background
    }),
    attrs: {
      "left-options": {
        showBack: _vm.showBack,
        backText: '',
        preventGoBack: _vm.preventGoBack
      }
    },
    on: {
      "on-click-back": _vm.customBack,
      "on-click-more": _vm.showMenus
    }
  }, [_c('span', {
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.headerTitle))])]), _vm._v(" "), _c('confirm', {
    attrs: {
      "title": "提示"
    },
    on: {
      "on-confirm": _vm.toBack
    },
    model: {
      value: (_vm.isAddworkBack),
      callback: function($$v) {
        _vm.isAddworkBack = $$v
      },
      expression: "isAddworkBack"
    }
  }, [_c('p', {
    staticClass: "fs26 c_666 textCenter"
  }, [_vm._v("你的工单尚未提交，是否确定返回？")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b2c4dec"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 555
// module chunks = 88